
export const session = {
    clear: clear,
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem
}
 function clear() {
 sessionStorage.clear();
}

function removeItem(key: any) {
    sessionStorage.removeItem(key);
}

 function setItem(key: any, value: any) {
    return sessionStorage.setItem(key, value);
}

function getItem(key: any) {
    return sessionStorage.getItem(key);
} 